export default "__VITE_PUBLIC_ASSET__28c55f52__"